import { Env } from "@voghion/fe-util";
import { navigateTo } from "@voghion/native-api";
import { showDialog } from "vant";
import { useI18n } from "vue-i18n";
const env = Env.getInstance();

export const showUpdateTips = async (
  country: string,
  t: ReturnType<typeof useI18n>["t"],
) => {
  const res = await showDialog({
    className: "clear-history-dialog",
    title: t("message.ai.updateTitle"),
    showCancelButton: true,
    cancelButtonText: t("message.ai.cancel"),
    confirmButtonText: t("message.ai.confirm"),
  });
  if (res) {
    const iosUrl = `https://apps.apple.com/${country.toLowerCase()}/app/voghion-one-stop-shop/id1568242949`;
    const androidUrl =
      "https://play.google.com/store/apps/details?id=com.voghion.app";
    navigateTo({
      url: `voghion://approuter/showWeb?openUrl=${encodeURI(env.isIOS ? iosUrl : androidUrl)}&external=1`,
    });
  }
};
